import { Outlet, useLocation } from "react-router-dom";
import { TopBar } from "@/components/layout/TopBar";
import { Sidebar } from "@/components/layout/Sidebar";
import { BottomNav } from "@/components/layout/BottomNav";
import { DemoBanner } from "@/components/layout/DemoBanner";
import { PageTransition } from "@/components/motion/PageTransition";
import { AITutorSheet } from "@/components/chat/AITutorSheet";
import { FloatingAITutorButton } from "@/components/chat/FloatingAITutorButton";

export function AppShell() {
  const location = useLocation();
  const isStudyModePicker = /^\/study\/[^/]+\/?$/.test(location.pathname);

  return (
    // min-h-screen falls back when dvh isn't supported; dvh tracks the
    // visible viewport height as the mobile URL bar shows / hides, so
    // the fixed BottomNav always sits at the real bottom of the window
    // instead of being pushed below by the URL-bar overlap.
    // min-w-0 lets flex children shrink properly; w-full + max-w-[100vw]
    // are belt-and-braces against any descendant pushing the root wider.
    <div className="min-h-screen min-h-[100dvh] flex flex-col bg-bg text-text w-full">
      <TopBar />
      <DemoBanner />
      <div className="flex flex-1 min-w-0">
        <Sidebar />
        {/* pb buffer clears the fixed BottomNav. Its visible height is
            h-16 (64px) + safe-area-inset-bottom, so a flat pb-20 (80px)
            left the last card masked behind the bar on home-indicator
            iPhones. Use a dynamic calc so it tracks the real safe area. */}
        <main className="flex-1 min-w-0 pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-0">
          <PageTransition>
            <Outlet />
          </PageTransition>
        </main>
      </div>
      <BottomNav />

      {/* AI Tutor sheet is mounted here too (in addition to StudyShell)
          so cross-chapter surfaces -- dashboard mini-prompt, etc. --
          can summon the chat via the ai-tutor-store. The picker gets a
          chapter-scoped FAB; viewer FABs stay in StudyShell. */}
      {isStudyModePicker ? <FloatingAITutorButton bottomOffset="nav" /> : null}
      <AITutorSheet />
    </div>
  );
}
